import React, { useEffect, useState } from 'react';
import { RacingFutureSpecialCompItems } from './racingFutureSpecialCompItems';

export const RacingFutureSpecialItems = ({
  region, onSelectGame, search, alwaysOpen, routePrefix
}) => {
  const [regClosed, SetRegClosed] = useState(false);

  const rergionDropDownClick = () => {
    SetRegClosed(!regClosed);
  };

  useEffect(() => SetRegClosed(false), [alwaysOpen]);

  return (
    <div className={`fs-region-container ${regClosed ? 'regClosed' : ''}`} key={region.id} onClick={!alwaysOpen && rergionDropDownClick}>
      <div className="region-name-container">
        <div className="regionName-Flag">
          <span
            className={`flag icon-${region.alias?.toLowerCase().replaceAll(' ', '')} flag`}
          />
          <span>{region.name}</span>
        </div>
        {!alwaysOpen && (
          <div className="arrow-section">
            {regClosed ? <i className="global-icon icon-thin-arrow-down" /> : <i className="global-icon icon-thin-arrow-up" />}
          </div>
        )}

      </div>

      {region.competitions.map((comp) => (
        <RacingFutureSpecialCompItems
          routePrefix={routePrefix}
          key={comp.id}
          comp={comp}
          region={region}
          onSelectGame={onSelectGame}
          search={search}
          alwaysOpen={region.competitions.length === 1 && region.length === 1}
        />
      ))}
    </div>
  );
};
